import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { environment } from "../../../../environments/environment";

@Component({
    selector: '[app-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor(public settings: SettingsService) { }

    ngOnInit() {

    }

    getVersion() {
        return environment && environment.version ? environment.version : '';
        /*const dateLivraison = environment.version; //this.settings.date_livraison; //23/01/2019-23:13
        if (dateLivraison.length<16) {
            return dateLivraison;
        }
        const version = dateLivraison.slice(6,10) // annee
            + dateLivraison.slice(3,5) // mois
            + dateLivraison.slice(0,2) // jour
            + dateLivraison.slice(11,13) // heure
            + dateLivraison.slice(14,16); // minute
        return version;*/
    }
    getDateLiv() {
        return environment && environment.date ? environment.date : '';
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/core/layout/footer/footer.component.ts